import {
  launchAd,
  launchRecord,
  updateLaunchRecordState,
  queryLaunchAdvertStatisticsData, // 投放统计
  statisticsQuery, // 统计数据查询
  statisticsQueryDetail, // 统计数据查询明细
  flowMainStatisticsQuery,
  approvateLaunchAdvert,
  launchApprovateRecord,
  approvateLaunchAdvertRecord,
  cancelLaunchAdvertRecord,
  flowMainDoStop,
  queryLaunchTimeRecord
} from '@/api/sys.launch'

export default {
  namespaced: true,
  actions: {
    /**
     * 广告投放
     */
    launchAd ({
      dispatch
    }, {
      vm,
      data
    }) {
      return launchAd(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    launchRecord ({
      dispatch
    }, {
      vm,
      data
    }) {
      return launchRecord(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    updateLaunchRecordState ({
      dispatch
    }, {
      vm,
      data
    }) {
      return updateLaunchRecordState(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    /**
     * 投放统计
     * @param {} param0
     * @param {*} param1
     */
    queryLaunchAdvertStatisticsData ({
      dispatch
    }, {
      vm,
      data
    }) {
      return queryLaunchAdvertStatisticsData(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    /**
     * 统计数据查询
     */
    statisticsQuery ({
      dispatch
    }, {
      vm,
      data
    }) {
      return statisticsQuery(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    /**
     * 统计数据查询明细
     * @param {} param0
     * @param {*} param1
     */
    statisticsQueryDetail ({
      dispatch
    }, {
      vm,
      data
    }) {
      return statisticsQueryDetail(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },

    /**
     * 统计数据查询
     */
    flowMainStatisticsQuery ({
      dispatch
    }, {
      vm,
      data
    }) {
      return flowMainStatisticsQuery(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    approvateLaunchAdvert ({
      dispatch
    }, {
      vm,
      data
    }) {
      return approvateLaunchAdvert(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    launchApprovateRecord ({
      dispatch
    }, {
      vm,
      data
    }) {
      return launchApprovateRecord(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    approvateLaunchAdvertRecord ({
      dispatch
    }, {
      vm,
      data
    }) {
      return approvateLaunchAdvertRecord(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    cancelLaunchAdvertRecord ({
      dispatch
    }, {
      data
    }) {
      return cancelLaunchAdvertRecord(data)
        .then(res => {
          return res
        })
    },
    flowMainDoStop ({
      dispatch
    }, {
      data
    }) {
      return flowMainDoStop(data)
        .then(res => {
          return res
        })
    },
    queryLaunchTimeRecord ({
      dispatch
    }, {
      data
    }) {
      return queryLaunchTimeRecord(data)
        .then(res => {
          return res
        })
    }

  }
}
